export const APP_STORE_URLS = {
  apple: 'https://apps.apple.com/us/app/american-drone-network/id6773354275',
  google: 'https://play.google.com/store/apps/details?id=com.americandronenetwork.android',
} as const;
